import * as React from "react";

import { useFormField } from "uiShadcn/form";
import { cn } from "utils/helpers/cn";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    dataTestId: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, dataTestId, required, ...props }, ref) => {
    const { error } = useFormField();

    return (
        <textarea
            className={cn(
                "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background",
                "placeholder:text-muted-foreground",
                "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                "disabled:cursor-not-allowed disabled:opacity-50",
                {
                    "border-destructive focus-visible:ring-destructive": !!error,
                },
                className,
            )}
            ref={ref}
            data-test-id={dataTestId}
            required={required}
            aria-required={required}
            {...props}
        />
    );
});
Textarea.displayName = "Textarea";

export { Textarea };
